module.exports = __webpack_public_path__ + "static/media/user-img-depoimento-video-02.ecde6d85.jpg";